<template>
  <div class="container">
    <div class="row">
      <h2 class="text-center hk-heading my-4">{{ $t('explore_industries.explore_industries_heading') }}</h2>
      <div class="col-md-6" v-for="(card, index) in cards" :key="index">
        <div class="card">
          <a :href="card.link" class="d-block">
            <div class="image-container my-4 mb-0">
              <img :src="card.imgSrc" class="card-img-top" :alt="card.alt" loading="lazy" />
            </div>
            <div class="outside-text-container">
              <h5 class="hk-miniheading text-decoration-none mt-3">
                {{ card.title }}
              </h5>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'ExploreIndustries',
  data() {
    return {
      cards: [
        {
          imgSrc: require('@/assets/home/explore-industries/other-industries-payment.webp'),
          title:  this.$t("explore_industries.card_one_title"),
          link: '/payment-key',
          alt: "Payments & Transactions | HotelKey"
        },
        {
          imgSrc: require('@/assets/home/explore-industries/other-industries-conventions.webp'),
          title: this.$t("explore_industries.card_two_title"),
          link: '/event-key',
          alt: "Conventions, Events & Activities | HotelKey"
        },
        {
          imgSrc: require('@/assets/home/explore-industries/other-industries-restaurant.webp'),
          title: this.$t("explore_industries.card_three_title"),
          link: '/retail-key',
          alt: "Restaurants & Food Services | HotelKey"
        },
        {
          imgSrc: require('@/assets/home/explore-industries/other-industries-leisure.webp'),
          title: this.$t("explore_industries.card_four_title"),
          link: null, // activity-key
          alt: "Leisure & Entertainment | HotelKey"
        },
      ],
    };
  },
};
</script>


<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";

.card {
    margin-bottom: 20px;
    border: 0;
}

.image-container {
    position: relative;
}

.card-img-top {
    width: 100%;
    height: auto;
    /* Ensure images maintain their aspect ratio */
}

.card-title {
    position: absolute;
    bottom: 10px;
    /* Adjust as needed */
    left: 10px;
    /* Adjust as needed */
    color: white;
    /* Change text color as necessary */
    padding: 5px;
}

.card-body {
    flex: 1 1 auto;
    padding: 10px 0px;
    color: var(--bs-card-color);
}

.outside-text-container {
    display: flex;
    justify-content: space-between;

}




</style>
